module.exports = __webpack_public_path__ + "static/media/cover-fb-totul-pentru-educatie-v3.79aa660d.jpg";